module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"varies":"variabel","The price depends on the settings chosen for each generation. Expand the row to see the individual charges.":"Der Preis hängt von den gewählten Einstellungen der jeweiligen Generierung ab. Zeile ausklappen, um die einzelnen Positionen zu sehen."}}')
  delete Component.options._Ctor
}
